export { EmittedEvent, EmittedEvent as Event } from './emitted_event';
export * from './eventemitter';
//# sourceMappingURL=index.js.map